/**
 * The canonical form of an agent's name: sigils and blank space off, which is
 * how a name is stored and how every reader compares one. One rule here
 * rather than one per reader, so a lead writing `@scout` and a lead writing
 * `scout` name one agent wherever the word is met — and a reader that strips
 * differently from the store is the one that disagrees with the row.
 */
export function toCanonicalAgentName(name: string): string {
  return name.replace(/^[\s@]+/, "").trim();
}
